import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';

export default class PasswordBoxViewModel extends ControlViewModel {

    /**
     * Der Wert der PasswordBox
     */
    public value: KnockoutObservable<string>;

    /**
     * Der Name der TextBox
     */
    public name: KnockoutObservable<string>;

    /**
     * Ein Handler, der aufgerufen wird, wenn sich der Wert verändert
     */
    public onChange: Function;

    /**
     * Ein Handler, der aufgerufen wird, wenn der Benutzer eine Taste drückt
     */
    public onKeyDown: Function;

    /**
     * Ein Handler, der aufgerufen wird, wenn der Benutzer Enter drückt
     */
    public onSubmit: (value: string) => void;

    /**
     * Ein Handler, der aufgerufen wird, wenn der Benutzer eine Taste loslässt
     */
    public onKeyUp: Function;

    /**
     * Gibt die maximale Länge des Passworts an
     */
    public maxLength: number;

    /**
     * Gibt an, ob das automatische Ausfüllen von Passwörtern ermöglicht sein soll
     */
    public autoFillEnabled: boolean;

    /**
     * Gibt den Platzhalter an (placeholder-Attribut)
     */
    public placeholder: KnockoutObservable<string>;

    /**
     *  Gibt an, ob an der PasswordBox ein Icon zur Anzeige des Passworts dargestellt werden soll
     */
    public showPasswordIcon: boolean;

    /**
     * Das ViewModel für die PasswordBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.value = this.observableOrDefault(params.value, '');
        this.name = this.observableOrDefault(params.name, '');
        this.onChange = this.handlerOrDefault(params.onChange);
        this.onKeyDown = this.handlerOrDefault(params.onKeyDown);
        this.onKeyUp = this.handlerOrDefault(params.onKeyUp);
        this.onSubmit = this.handlerOrDefault(params.onSubmit);
        this.maxLength = this.paramOrDefault(params.maxLength, -1);
        this.autoFillEnabled = this.paramOrDefault(params.autoFillEnabled, false);
        this.placeholder = this.observableOrDefault(params.placeholder, '');
        this.showPasswordIcon = this.paramOrDefault(params.showPasswordIcon, false);
    }

    /**
     * @override
     */
    public resetValue(): void {
        this.value('');
    }
}

ComponentManager.setViewModel('PasswordBoxViewModel', PasswordBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');